import { HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

interface ToastHeaderProps extends HTMLAttributes<HTMLDivElement> {
  className?: string
}

export function ToastHeader({ className, children, ...props }: ToastHeaderProps) {
  return (
    <div className={twMerge('flex items-center gap-2.5', className)} {...props}>
      <div className="flex min-w-0 flex-1 items-start gap-2">{children}</div>
    </div>
  )
}
